import React, { useCallback, useEffect, useRef, useState } from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import BodyText from 'components/Luxkit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import Image from 'components/Common/Image'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'

interface Props {
  title: string
  description: string
  primaryActionText: string
  onClickAction: () => void
  onClose: () => void
}

const DEFAULT_LOADING_TIME_IN_MS = 3000

function WhiteLabelAppPromoModal({ title, description, primaryActionText, onClickAction, onClose }: Props) {
  const [isLoading, setIsLoading] = useState(false)
  const modal = useModalElementContext()
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const timeout = timeoutRef.current
    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [])

  const close = useCallback(() => {
    onClose()
    modal.resolve()
  }, [modal, onClose])

  const handlePrimaryAction = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    setIsLoading(true)
    onClickAction()

    timeoutRef.current = setTimeout(() => {
      setIsLoading(false)
      modal.resolve()
    }, DEFAULT_LOADING_TIME_IN_MS)
  }, [onClickAction, modal])

  return <ModalBase>
    <ModalHeader title="" isOverlay />
    <ModalBody>
      {/* <Image image={{ id: '045v9wnpstre73nsshp' }} dpr={2} width={250} fit="center" /> staging */}
      <Image image={{ id: 'fz6znfw35rsy6dt810c' }} dpr={2} width={250} fit="center" />
      <ModalContent>
        <Group direction="vertical" gap={12}>
          <Heading variant="heading3">{title}</Heading>
          <BodyText variant="large">{description}</BodyText>
        </Group>
      </ModalContent>
    </ModalBody>
    <ModalFooter
      primaryActionProps={{
        children: isLoading ? 'Opening Grill\'d...' : primaryActionText,
        disabled: isLoading,
        onClick: handlePrimaryAction,
      }}
      secondaryActionProps={{
        children: 'Don\'t show it again',
        disabled: isLoading,
        onClick: close,
      }}
    />
  </ModalBase>
}

export default WhiteLabelAppPromoModal
